<template>
    <div>
        <!-- <b-card v-show="mostrarTabela" no-body>
			<b-card-header>
				<span class="h5">Contratos</span>
			</b-card-header>
		<b-card-body>-->
        <app-tabela
            idTabela="tblApostilamentos"
            :itens="apostilamentosFiltrados"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <b-row>
                    <b-col sm="12">
                        <b-form inline class="justify-content-end">
                            <label class="mr-sm-2">Item Apostilamento</label>
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="itensApostilamento"
                                v-model="itemApostilamento"
                            ></b-form-select>
                            <!-- <label class="mr-sm-2">Status</label>
                  <b-form-select
                    class="mb-2 mb-sm-0"
                    :plain="true"
                    :options="tituloStatusOptions"
                    v-model="tituloStatus">
							</b-form-select>-->
                        </b-form>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-mostrar-justificativa
                    :apostilamento="data"
                ></btn-mostrar-justificativa>
            </template>
        </app-tabela>
        <!-- </b-card-body>
		</b-card>
		<router-view></router-view>-->
    </div>
</template>

<script>
import BtnMostrarJustificativa from './BtnMostrarJustificativa'

export default {
    components: { BtnMostrarJustificativa },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            itensApostilamento: [
                { value: 0, text: 'TODOS' },
                { value: '% GARANTIA', text: '% GARANTIA' },
                { value: 'DATA ENVIO DIRETORIA', text: 'DATA ENVIO DIRETORIA' },
                {
                    value: 'DATA ENVIO FORNECEDOR',
                    text: 'DATA ENVIO FORNECEDOR'
                },
                {
                    value: 'DATA FIM PRAZO EXECUÇÃO',
                    text: 'DATA FIM PRAZO EXECUÇÃO'
                },
                { value: 'DATA FIM VIGÊNCIA', text: 'DATA FIM VIGÊNCIA' },
                {
                    value: 'DATA INÍCIO PRAZO EXECUÇÃO',
                    text: 'DATA INÍCIO PRAZO EXECUÇÃO'
                },
                { value: 'DATA INÍCIO VIGÊNCIA', text: 'DATA INÍCIO VIGÊNCIA' },
                {
                    value: 'DATA RETORNO DIRETORIA',
                    text: 'DATA RETORNO DIRETORIA'
                },
                {
                    value: 'DATA RETORNO FORNECEDOR',
                    text: 'DATA RETORNO FORNECEDOR'
                },
                {
                    value: 'DETALHE DA FASE DO CONTRATO',
                    text: 'DETALHE DA FASE DO CONTRATO'
                },
                { value: 'DOCUMENTO', text: 'DOCUMENTO' },
                { value: 'DOTAÇÃO ORÇAMENTÁRIA', text: 'DOTAÇÃO ORÇAMENTÁRIA' },
                { value: 'GARANTIA', text: 'GARANTIA' },
                { value: 'FASE DO CONTRATO', text: 'FASE DO CONTRATO' },
                { value: 'GESTOR', text: 'GESTOR' },
                { value: 'ITEM DE CONTRATO', text: 'ITEM DE CONTRATO' },
                { value: 'OBJETO DO CONTRATO', text: 'OBJETO DO CONTRATO' },
                { value: 'RESPONSÁVEL CONTRATO', text: 'RESPONSÁVEL CONTRATO' },
                { value: 'TIPO DO CONTRATO', text: 'TIPO DO CONTRATO' },
                { value: 'SUB ITEM DE CONTRATO', text: 'SUB ITEM DE CONTRATO' },
                { value: 'UNIDADE', text: 'UNIDADE' }
            ],
            itemApostilamento: 0,
            campos: [
                {
                    key: 'dataCadastro',
                    label: 'Data',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'usuarioAtualizacao',
                    label: 'Usuário',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'item',
                    label: 'Item',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dadoAnterior',
                    label: 'Dado Anterior',
                    filterable: true
                },
                {
                    key: 'dadoAtualizado',
                    label: 'Dado Atualizado',
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            apostilamentosFiltrados: []
        }
    },
    methods: {},

    created() {
        this.apostilamentosFiltrados = this.contrato.apostilamentos
    },

    computed: {},

    watch: {
        itemApostilamento() {
            if (this.itemApostilamento === 0) {
                this.apostilamentosFiltrados = this.contrato.apostilamentos
            } else {
                this.apostilamentosFiltrados = this.contrato.apostilamentos.filter(
                    item => {
                        return item.item === this.itemApostilamento
                    }
                )
            }
        },

        'contrato.apostilamentos'() {
            if (this.itemApostilamento === 0) {
                this.apostilamentosFiltrados = this.contrato.apostilamentos
            } else {
                this.apostilamentosFiltrados = this.contrato.apostilamentos.filter(
                    item => {
                        return item.item === this.itemApostilamento
                    }
                )
            }
        }
    }
}
</script>
